<template>
  <div class="home-box">
    <p class="title">《用户授权协议》</p>
    <p class="desc">
      《用户授权协议》（以下简称“本协议”）是北京星图数网科技有限公司与用户（以下简称“您”）所订立的有效合约。
    </p>
    <p class="main">
      【审慎阅读】您即将通过本页面使用产品账户授权登录第三方站点/软件或进行一定数据共享。确认授权前请您仔细阅读本协议的全部内容（特别是以粗体下划线标注的内容）。如您不同意本协议内容，或无法准确理解本协议任何条款的含义，请不要进行授权及后续操作。
    </p>
    <p class="main">
      【签约动作】您通过网络页面确认同意接受本协议，视为您同意接受本协议的全部约定内容。
    </p>
    <p class="main">
      【共享信息】您授权产品将您账户的相关信息和数据传递给第三方，用于第三方为您提供服务。页面提示上会展示具体授权对象、授权字段及内容等，授权字段及内容将通过加密通道传递给第三方。如您不希望向第三方提供上述信息，请勿点击确认授权。
    </p>
    <p class="main">
      【责任承担】您理解，第三方服务由相应第三方提供并就以上服务及数据安全独立承担责任。因该第三方服务或其使用您的信息产生的纠纷，或第三方服务违反相关法律法规，或您在使用第三方服务过程中遭受的损失，请您与第三方协商解决。
    </p>
    <p class="main">
      【安全提示】网络欺诈往往会模仿、仿冒本登录页面的样式制作视觉感相似的页面引诱用户输入账号和密码等信息，提醒您防范网络风险，不要向非星图的站点或任何人士透露您的星图平台账户的名称、密码等相关信息。
    </p>
    <p class="main">
      【协议变更】您同意，可不时修订本协议，并将协议变更情况在星图平台的网站/客户端上进行公示，该等变更自公告载明的生效时间开始生效，并成为本协议的一部分。
    </p>
    <p class="main">
      【争议解决】凡因本协议引起的及任何与之有关的争议，首先应由该等争议的相关当事方通过友好协商解决，如果无法友好协商解决的，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。
    </p>
  </div>
</template>

<script>
export default {
  name: 'carrousel',
  data() {
    return {
      
    }
  },
  components: {},
  mounted () {
    
  },
  computed: {},
  methods: {
    
  },
}
</script>

<style lang="scss" scoped>
  .home-box{
    padding: 10px 30px;
    .title{
      font-size: 16px;
      font-weight: 600;
    }
    .desc,.main{
      text-align: left;
      font-size: 10px;
      text-indent: 20px;
      margin-top: 8px;
    }
  }
</style>